export default class StorageList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.company_db_id] = this.index[entry.company_db_id] || {}
			this.index[entry.company_db_id][entry.id] = entry
		}
	}

	static async fetch () {

		let data = await Anvil.REST.get('/c_order/storage/list')

		return new StorageList(data)
	}

	getById (company_db_id, id) {
		return this.index[company_db_id] ? this.index[company_db_id][id] : null
	}
}
